"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var NChangedProdThresholdDTO_1 = require("../model/NChangedProdThresholdDTO");

var NotificationDocConverter_1 = require("../NotificationDocConverter");

var NChangedProdThresholdConverterImpl_1 = require("./NChangedProdThresholdConverterImpl");

var NChangedProdThresholdDTOConverter_1 = require("./NChangedProdThresholdDTOConverter");
/**
 * @author Tomas Leity
 */


var NChangedProdThresholdDTOConverterImpl =
/*#__PURE__*/
function (_NChangedProdThreshol) {
  _inherits(NChangedProdThresholdDTOConverterImpl, _NChangedProdThreshol);

  /**
   * @param productObjectConverter
   */
  function NChangedProdThresholdDTOConverterImpl(productObjectConverter) {
    var _this;

    _classCallCheck(this, NChangedProdThresholdDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThresholdDTOConverterImpl).call(this));
    _this.productObjectConverter = productObjectConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NChangedProdThresholdDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NChangedProdThresholdDTO_1.NChangedProdThresholdDTO(NChangedProdThresholdDTO_1.NChangedProdThresholdDTO.schema.products.valueOf(conversions.asObjectList(source, 'products', function (obj) {
        return _this2.productObjectConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        products: conversions.asObjectArray(source, 'products', function (obj) {
          return _this3.productObjectConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NChangedProdThresholdDTOConverterImpl;
}(NChangedProdThresholdDTOConverter_1.NChangedProdThresholdDTOConverter);
/**
 * IOC Container qualifier
 */


NChangedProdThresholdDTOConverterImpl.QUALIFIER = {
  documentType: NChangedProdThresholdDTO_1.NChangedProdThresholdDTO.name
};
NChangedProdThresholdDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject(NChangedProdThresholdConverterImpl_1.NChangedProdThresholdConverterImpl.QUALIFIER)), __metadata("design:paramtypes", [NotificationDocConverter_1.NotificationDocConverter])], NChangedProdThresholdDTOConverterImpl);
exports.NChangedProdThresholdDTOConverterImpl = NChangedProdThresholdDTOConverterImpl;